import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { SessionExpiryMonitor } from "./components/SessionExpiryMonitor";
import { AuthProvider } from "./context/AuthContext";
import { LoginPage } from "./pages/LoginPage";
import { QuarantinePage } from "./pages/QuarantinePage";
import { QuotaRequestMessageListPage } from "./pages/QuotaRequestMessageListPage";
import { CQRM_ACCESS_ROLES } from "./types";

export default function App() {
  return (
    <AuthProvider>
      <SessionExpiryMonitor />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoute roles={CQRM_ACCESS_ROLES} />}>
          <Route path="/" element={<QuarantinePage />} />
          <Route
            path="/quota_request/:quotaRequestId/message/list"
            element={<QuotaRequestMessageListPage />}
          />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
